module.exports = __webpack_public_path__ + "media/images/svg/logos-next-generation-9e3cdc7a09c5d6e08c590051bf0bf115.svg";